import * as React from "react"
import Svg, { Path } from "react-native-svg"

const SVGChevronRight = (props) => (
  <Svg xmlns="http://www.w3.org/2000/svg" height={24} width={24} {...props}>
    <Path d="M0 0h24v24H0V0z" fill="none" />
    <Path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z" />
  </Svg>
)

export default SVGChevronRight;